import { useState, useEffect, useCallback } from "react";
import {
  fetchFriends, fetchPendingFriends,
  sendFriendRequest, acceptFriend, rejectFriend,
  cancelFriendRequest, removeFriend,
} from "../api/friends";

export function useFriends() {
  const [friends, setFriends]   = useState([]);
  const [pending, setPending]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const [f, p] = await Promise.all([fetchFriends(), fetchPendingFriends()]);
      setFriends(f);
      setPending(p);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const send   = async (username) => { await sendFriendRequest(username);   await reload(); };
  const accept = async (id)       => { await acceptFriend(id);              await reload(); };
  const reject = async (id)       => { await rejectFriend(id);              await reload(); };
  const cancel = async (id)       => { await cancelFriendRequest(id);       await reload(); };
  const remove = async (id)       => { await removeFriend(id);              await reload(); };

  return { friends, pending, loading, error, send, accept, reject, cancel, remove };
}
